module.exports = __webpack_public_path__ + "img/person-2.06cfd81c.png";